import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import { ref } from 'vue';
import axios from 'axios';
// 整体的定义一下格式
export default /*#__PURE__*/ _defineComponent({
    __name: 'home-channel',
    setup: function (__props) {
        var active = ref(0);
        // 定义一个响应式数据，初始值设置一个空数组
        // TS的接口 用于标记数据格式
        var list = ref([]);
        axios({
            url: '/navList',
            method: 'get'
        }).then(function (res) {
            console.log(res.data);
            // 这时候别忘了.value
            list.value = res.data.result;
        });
        return function (_ctx, _cache) {
            var _component_van_tab = _resolveComponent("van-tab");
            var _component_van_tabs = _resolveComponent("van-tabs");
            return (_openBlock(), _createBlock(_component_van_tabs, {
                active: active.value,
                "onUpdate:active": _cache[0] || (_cache[0] = function ($event) { return ((active).value = $event); })
            }, {
                default: _withCtx(function () { return [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                        return (_openBlock(), _createBlock(_component_van_tab, {
                            key: item.id,
                            title: item.text
                        }, null, 8, ["title"]));
                    }), 128))
                ]; }),
                _: 1
            }, 8, ["active"]));
        };
    }
});
